module.exports = __webpack_public_path__ + "static/media/vegas-small.5e80c5f6.webp";